module.exports = __webpack_public_path__ + "img/test.e4d6ba6f.png";